import { baseDialogStyles } from '../baseDialogStyles.js';
import { mergeDeepRight } from 'ramda';

export const styles = (theme) => {
    const _baseDialogStyles = baseDialogStyles(theme);
    const _styles = {
        header: {
            background: theme.palette.error.main,
            color: theme.palette.text.white
        },
        formName: {
            padding: '10px 20px',
            margin: '10px 0px',
            backgroundColor: theme.palette.background.light,
            wordBreak: 'break-word'
        },
        deleteBtn: {
            color: theme.palette.error.main
        }
    };

    return mergeDeepRight(_baseDialogStyles, _styles);
}
